import {intlShape, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import stylesAutoLayout from '../AutoLayout.less';
import AutoLayoutUtils from 'src/js/containers/auto_layout/auto_layout_utils';
import {ModifiedAsterisk} from 'src/js/containers/auto_layout/components';
import AutoLayoutService from 'src/js/lib/auto_layout/auto_layout_service';
import {ContentProperty} from 'src/js/model/auto_layout_content_schema';
import {LayoutProperty} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

class InputComponentWrapper extends React.PureComponent {
  render() {
    const {
      children,
      pathToData,
      content,
      isCollapsed,
      layout,
      readOnly,
      textOnly,
      screenId,
      idSuffix,
      intl,
      isChanged,
      data,
      rootData,
      ...restProps
    } = this.props;
    const inputName = [pathToData, 'input'].join('_');
    const isReadOnly = layout.getReadOnly() || readOnly === true;
    // check if the component is conditional
    let isShown = true;
    if (content.isConditional()) {
      isShown = AutoLayoutUtils.checkDataConditions(
        content.getConditions(),
        rootData
      );
    }
    if (layout.getHiddenValues()) {
      isShown = !AutoLayoutUtils.isValueInList(layout.getHiddenValues(), data);
    }

    const isTextOnly = textOnly === true;
    const isReallyCollapsed = !!layout.isCollapsible() && isCollapsed;
    const label = layout.getLabel()
      ? utils.TranslateUtils.translate({id: layout.getLabel()}, intl)
      : undefined;
    return isShown ? (
      <div
        id={AutoLayoutService.getComponentId(screenId, pathToData, idSuffix)}
        className={classNames(
          'form-group',
          stylesAutoLayout.dlScreenComponent,
          {
            [stylesAutoLayout.dlTextOnly]: isTextOnly,
          }
        )}
        hidden={isReallyCollapsed}
      >
        {/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */}
        {label ? (
          <label htmlFor={inputName} title={label}>
            <ModifiedAsterisk isModified={isChanged} />
            {label}
          </label>
        ) : (
          <ModifiedAsterisk isModified={isChanged} />
        )}
        {/* eslint-enable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */}
        {React.Children.map(children, (child) =>
          React.cloneElement(child, {
            ...restProps,
            pathToData,
            data,
            layout,
            inputName,
            screenId,
            idSuffix,
            isReadOnly,
            isTextOnly,
            label,
            // reset child props
            dataChanges: undefined,
            rootData: undefined,
            readOnly: undefined,
            textOnly: undefined,
          })
        )}
      </div>
    ) : null;
  }
}

InputComponentWrapper.displayName = 'InputComponentWrapper';

InputComponentWrapper.propTypes = {
  content: PropTypes.instanceOf(ContentProperty).isRequired,
  isChanged: PropTypes.bool,
  dataSets: PropTypes.objectOf(PropTypes.any).isRequired,
  layout: PropTypes.instanceOf(LayoutProperty).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  idSuffix: PropTypes.string,
  intl: intlShape.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  rootData: PropTypes.objectOf(PropTypes.any),
  pathToData: PropTypes.string,
  readOnly: PropTypes.bool,
  textOnly: PropTypes.bool,
  expanded: PropTypes.bool,
  onDataChange: PropTypes.func.isRequired,
};

InputComponentWrapper.defaultProps = {
  data: {},
  rootData: {},
  idSuffix: '',
  isChanged: false,
  pathToData: '',
  readOnly: false,
  textOnly: false,
  expanded: false,
};

export default injectIntl(InputComponentWrapper);
